document.addEventListener('DOMContentLoaded', () => {
  const articles = Array.from(document.querySelectorAll('.blog-all-section li.article'));
  const articleList = document.querySelector('.all-articles');
  const tabHeadings = document.querySelectorAll('.mm-tab__heading');
  const blogSection = document.querySelector('.blog-all-section');
  const searchInput = document.getElementById('documentSearch');

  let currentIndex = 0;
  const initialLoadCount = 6;
  const loadMoreCount = 3;

  function sortArticles() {
    articles.sort((a, b) => {
      const dateA = new Date(a.getAttribute('custom-date'));
      const dateB = new Date(b.getAttribute('custom-date'));
      return dateB - dateA;
    });

    articleList.innerHTML = '';

    function loadArticles(count) {
      const loadingIndicator = document.querySelector('.loading-indicator');
      loadingIndicator.style.display = 'block';

      setTimeout(() => {
        for (let i = 0; i < count && currentIndex < articles.length; i++, currentIndex++) {
          const article = articles[currentIndex];
          article.classList.add('visible');
          articleList.appendChild(article);
        }
        loadingIndicator.style.display = 'none';
      }, 500);
    }

    loadArticles(initialLoadCount);

    function checkScroll() {
      const lastArticle = document.querySelector('.all-articles li.article:last-child');

      if (lastArticle) {
        const {
          top
        } = lastArticle.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        if (top < 200 && currentIndex < articles.length) {
          loadArticles(loadMoreCount);
        }
      }
    }

    window.addEventListener('scroll', checkScroll);
  }

  function filterArticles() {
    const query = searchInput.value.toLowerCase();
    currentIndex = 0;
    articleList.innerHTML = '';

    const filteredArticles = articles.filter(article => {
      const title = article.textContent.toLowerCase();
      return title.includes(query);
    });
    const loadCount = query ? filteredArticles.length : initialLoadCount;
    for (let i = 0; i < loadCount && i < filteredArticles.length; i++) {
      filteredArticles[i].classList.add('visible');
      articleList.appendChild(filteredArticles[i]);
    }
  }

  searchInput.addEventListener('input', filterArticles);
  document.addEventListener('DOMContentLoaded', sortArticles);


  function updateBlogSectionClass() {
    const isAllActive = Array.from(tabHeadings).some(tab =>
      tab.getAttribute('data-year') === 'year-all' && tab.classList.contains('is--active')
    );
    if (isAllActive) {
      blogSection.classList.add('active');
    } else {
      blogSection.classList.remove('active');
    }
  }

  tabHeadings.forEach(tab => {
    tab.addEventListener('click', () => {
      tabHeadings.forEach(t => t.classList.remove('is--active'));
      tab.classList.add('is--active');
      updateBlogSectionClass();
    });
  });

  sortArticles();
  updateBlogSectionClass();
});